import React, { useState } from 'react';
import { observer } from 'mobx-react';
import ErrorIcon from '@mui/icons-material/Error';
import MenuIcon from '@mui/icons-material/Menu';
import {
    Drawer,
    IconButton,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { ThemedStep } from '../../themed/ThemedComponents';
import './sidebar.scss';

function Sidebar({ steps, activeStep, allowedSteps, onStepChange, warningSteps }) {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const sidebarContent = (
        <div className="assessment-wizard-steps">
            {steps.map((s, i) => (
                <ThemedStep
                    key={`step-${s.number}`}
                    active={activeStep === s.number}
                    enabled={allowedSteps.includes(s.number)}
                    onClick={() => {
                        if (allowedSteps.includes(s.number)) {
                            onStepChange(s.number);
                            if (isSmallScreen) setDrawerOpen(false);
                        }
                    }}
                >
                    {i + 1}. {s.title}
                    {warningSteps.includes(i + 1) && (
                        <ErrorIcon
                            color="error"
                            fontSize="inherit"
                            style={{ marginLeft: '10px', marginBottom: '4px' }}
                        />
                    )}
                </ThemedStep>
            ))}
        </div>
    );

    if (isSmallScreen) {
        return (
            <div>
                <IconButton onClick={() => setDrawerOpen(true)} size="large">
                    <MenuIcon />
                </IconButton>
                <Drawer
                    anchor="left"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                >
                    {sidebarContent}
                </Drawer>
            </div>
        );
    }

    return sidebarContent;
}

export default observer(Sidebar);
